// extracted by mini-css-extract-plugin
module.exports = {"base":"caption_base__RiZP9"};